<template>
  <div
    ref="symbology"
  >
    <v-card
      v-show="showSymbology"
      :style="cardStyle"
    >
      <v-toolbar
        color="primaryLight"
        dark
        dense
      >
        <v-toolbar-title
          v-if="!minimized"
        >
          Plan de operaciones
        </v-toolbar-title>
        <v-spacer v-if="!minimized" />
        <v-btn
          icon
          @click="toggleMinimize"
        >
          <v-icon> {{ chevronIcon }}</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text
        style="height: 92%;"
        v-show="!minimized"
      >
        <v-container class='full-height d-flex flex-column' fluid style="height: 100%;">
          <!-- Modos -->
          <div class="section-modo">
            <v-row dense>
              <v-col>
                <p class="section-title">Modo</p>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col
                v-for="item in modos"
                :key="item.value"
                :cols="12 / modos.length"
              >
                <v-card
                  :color="modo === item.value ? '#34515C' : 'white'"
                  :dark="modo === item.value"
                  :class="['modo-card compact', { 'modo-activo': modo === item.value }]"
                  elevation="4"
                  @click="modo = item.value"
                >
                  <div class="modo-label">
                    <span>{{ item.label }}</span>
                    <v-icon
                      size="16"
                      :color="modo === item.value ? 'white' : '#537582'"
                    >
                      {{ item.icon }}
                    </v-icon>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
          <!-- Divider -->
          <v-row dense>
            <v-col>
              <div class="section-divider"></div>
            </v-col>
          </v-row>
          <!-- Panel -->
          <div class='section-panel'>
            <v-row dense class="mb-5">
              <v-col>
                <p class="section-title">
                  Panel
                </p>
              </v-col>
            </v-row>
            <!-- Modo simbología -->
            <PanelSymbology
              v-if="modo === 'simbolo'"
              @paint="paint"
              @selected="selectDrawing"
            />
            <!-- Modo texto -->
            <PanelLine
              v-if="modo === 'linea'"
              @paint="paint"
            />
            <!-- Modo texto -->
            <PanelText
              v-if="modo === 'texto'"
              @paint="paint"
            />
          </div>
          <!-- Divider -->
          <v-row dense>
            <v-col>
              <div class="section-divider"></div>
            </v-col>
          </v-row>
          <!-- Elementos -->
          <div class='section-elementos'>
            <v-row dense>
              <v-col>
                <p class="section-title">
                  Elementos ({{ graphics.length }})
                  <v-icon small>mdi-layers-double</v-icon>
                </p>
              </v-col>
            </v-row>
            <v-row class="element-list">
              <v-col cols="12">
                <v-list dense class="pa-0 bg-transparent" v-if="graphics.length > 0">
                  <draggable
                    v-model="graphics"
                    item-key="ID_GRAFICO"
                    handle=".drag-handle"
                    ghost-class="drag-ghost"
                    tag="div"
                    @end="onDragEnd"
                  >
                    <v-list-item
                      v-for="(graphic, index) in graphics"
                      :key="index"
                      class="element-item"
                    >
                      <!-- Drag -->
                      <v-icon
                        small
                        class="drag-handle mr-2"
                      >
                        mdi-drag-horizontal
                      </v-icon>

                      <!-- Nombre -->
                      <div class="element-content">
                        <!-- Lectura -->
                        <span
                          v-if="editingId !== graphic.ID_GRAFICO"
                          class="element-label"
                        >
                          {{ graphic.LABEL }}
                        </span>
                      </div>
                    </v-list-item>
                  </draggable>
                </v-list>
              </v-col>
            </v-row>
          </div>
          <!-- Divider -->
          <v-row dense>
            <v-col>
              <div class="section-divider"></div>
            </v-col>
          </v-row>
          <!-- Footer -->
          <div class='section-footer'>
            <v-row dense>
              <v-col class="d-flex">
                <v-btn
                  class="btn-footer-crear flex-grow-1"
                  depressed
                  @click="finishDrawing"
                >
                  Añadir gráficos
                </v-btn>
              </v-col>

              <v-col class="d-flex">
                <v-btn
                  class="btn-footer-crear flex-grow-1"
                  depressed
                  @click="exitDrawing"
                >
                  Salir
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
    <!-- Snackbar dibujo actual -->
    <v-snackbar
      v-model="isDrawing"
      button
      :timeout="-1"
    >
      Haz click en el mapa
      <template
        #action="{ attrs }"
      >
        <v-btn
          text
          color="pink"
          v-bind="attrs"
          @click="cancelCurrentDrawing"
        >
          Cancelar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import * as ArcGIS from '../../helpers/ArcGIS'

import draggable from 'vuedraggable'
import PanelSymbology from './symbology/PanelSymbology.vue'
import PanelText from './symbology/PanelText.vue'
import { mapActions } from 'vuex'
import PanelLine from './symbology/PanelLine.vue'

export default {
  components: { draggable, PanelSymbology, PanelText, PanelLine },

  data: () => ({
    modo: 'simbolo',
    modos: [
      { value: 'simbolo', label: 'Simbología', icon: 'mdi-shape' },
      { value: 'linea', label: 'Línea', icon: 'mdi-vector-line' },
      { value: 'texto', label: 'Texto', icon: 'mdi-format-text' }
    ],

    showSymbology: false,
    callback: null,

    minimized: false,

    showDialogText: false,
    textSelected: '',
    sizeSelected: 16,

    activeBtn: null,

    isDrawing: false,

    graphics: [],
    graphicsSnap: [],

    isValidText: false,

    lineSelected: null,
    lineSelectedEscenario: null,
    lineSelectedSITAC: null,
    polygonSelected: null,

    medio_externo: false,

    editingId: null,
    idIncendio: null
  }),

  computed: {
    cardStyle() {
      const toolbarSize = 48

      return {
        position: 'absolute',
        left: '0px',
        top: '0px',
        bottom: this.minimized ? 'auto' : '5px',
        width: this.minimized ? `${toolbarSize}px` : '35rem',
        height: this.minimized ? `${toolbarSize}px` : 'auto',
        overflow: 'hidden',
        transition: 'all 160ms ease',
        backgroundColor: '#537582CC',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)'
      }
    },

    chevronIcon() {
      return this.minimized ? 'mdi-chevron-right' : 'mdi-chevron-left'
    }
  },

  mounted() {
    this.$eventHub.$on('showSymbology', this.showPanelSymbology)
  },

  beforeDestroy() {
    this.$eventHub.$off('showSymbology', this.showPanelSymbology)
  },

  methods: {
    ...mapActions('map', ['setActiveDrawSymbologyPanel', 'clearActiveDrawSymbologyPanel']),

    async showPanelSymbology(data) {
      try {
        this.showSymbology = true

        this.callback = data.callback // Funcion a la que se va a llamar al finalizar, se recibe por el eventhub y se le envian los graphics
        this.graphics = data.graphics
        this.graphicsSnap = [...data.graphics]
        this.idIncendio = data.idIncendio

        await this.setActiveDrawSymbologyPanel('ppoo')

        ArcGIS.initPlanOperacionesSketchViewModel({
          callbackCreate: this.onDrawCreated,
          callbackUpdate: this.onDrawUpdated,
          callbackDelete: this.onDrawDeleted
        })
        await ArcGIS.drawGraphicsPlanOperaciones(this.graphics)
      } catch (error) {
        console.error('Error en showPanelSymbology:', error)
        this.$notify({
          title: 'Error',
          text: 'Error al mostrar el panel de simbología',
          type: 'error'
        })
      }
    },

    selectDrawing(drawing) {
      this.isDrawing = drawing
    },

    paint(event) {
      ArcGIS.paintEventPlanOperaciones(event)
    },

    onDragEnd() {
      this.graphics.forEach((g, i) => {
        g.ORDEN = i + 1
      })
    },

    toggleMinimize() {
      this.minimized = !this.minimized
    },

    // #region CALLBACKS ARCGIS
    onDrawCreated(data) {
      data.ORDEN = this.graphics.length + 1
      data.LABEL = data.attributes?.LABEL?.label || 'Sin nombre'
      this.isDrawing = false
      this.activeBtn = null
      this.graphics.push(data)
    },
    onDrawUpdated(data) {
      const atributos = data.ATRIBUTOS
      const geometria = data.GEOMETRIA
      const index = this.graphics.findIndex(
        (x) => x.ID_GRAFICO === atributos.ID_GRAFICO
      )

      if (index !== -1) {
        this.graphics[index].ATRIBUTOS = JSON.stringify(atributos)
        this.graphics[index].GEOMETRIA = JSON.stringify(geometria)
      }
    },

    onDrawDeleted(idGrafico) {
      const index = this.graphics.findIndex(
        (x) => x.attributes.ID_GRAFICO === idGrafico
      ) // TODO: attributes por ATRIBUTOS

      if (index !== -1) {
        this.graphics.splice(index, 1)
      }
    },
    // #endregion

    // Finaliza el dibujo y lo envia de vuelta
    finishDrawing() {
      this.showSymbology = false
      this.isDrawing = false
      this.activeBtn = null

      ArcGIS.stopPlanOperacionesSketchViewModel()
      this.callback(this.graphics)
      this.callback = null
      this.clearActiveDrawSymbologyPanel()
      this.$emit('closeSymbology', this.idIncendio)
    },

    // Finaliza el dibujo y devuelve el snapshot de los graficos
    exitDrawing() {
      this.showSymbology = false
      this.isDrawing = false
      this.activeBtn = null

      ArcGIS.stopPlanOperacionesSketchViewModel()
      this.callback(this.graphicsSnap)
      this.callback = null
      this.clearActiveDrawSymbologyPanel()
      this.$emit('closeSymbology', this.idIncendio)
    },

    // Cancela el dibujo actual
    cancelCurrentDrawing() {
      this.isDrawing = false
      this.activeBtn = null

      ArcGIS.paintEventPlanOperaciones('cancel')
    }
  }
}
</script>

<style scoped>
::v-deep .v-tabs-items {
  background: transparent !important;
}

::v-deep .v-window,
::v-deep .v-window__container,
::v-deep .v-window-item {
  background: transparent !important;
}

.modo-card {
  height: 20px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 14px;
  transition: all 0.25s ease;
  border: 2px solid #53758233;
}

.modo-card:hover {
  transform: translateY(-3px);
}

.modo-activo {
  border: 2px solid #537582;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 1.25rem;
  font-weight: 500;
  color: #fff;
  margin: 0px;
}

.element-content {
  flex: 1;
  overflow: hidden;
}

.visibility-btn {
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.visibility-btn:hover {
  opacity: 1;
}

.edit-input .v-input__control {
  min-height: 28px !important;
}

.tab-grid {
  display: flex;
  flex-wrap: nowrap;
  gap: 4px;
  overflow-x: auto;
}

.tab-pill {
  flex: 1;
  text-align: center;
  padding: 2px 4px;
  font-size: 10px;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: white;
  border: 1px solid #e0e0e0;
  color: #537582;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tab-pill:hover {
  background: #f3f6f7;
}

.tab-pill.active {
  background: #34515C;
  color: white;
  border-color: #537582;
}

.modo-card.compact {
  padding: 6px 10px;
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 12px;
  transition: all 0.2s ease;
  border: 2px solid #53758233;
}

.modo-card.compact:hover {
  transform: translateY(-2px);
}

.modo-card.compact .modo-label {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  color: inherit;
}

.modo-card.compact.modo-activo {
  border-color: #537582;
}

.btn-footer-crear {
  flex: 1 1 0;
  width: 50%;
  border-radius: 9999px;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 0.8rem;
  min-height: 34px;
  padding: 0 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.section-divider {
  height: 1px;
  background-color: rgba(255, 255, 255, 0.3);
  margin: 12px 0;
  border-radius: 1px;
}

.section-modo {
  height: auto;
  overflow-y: hidden;
  overflow-x: hidden;
}
.section-panel {
  height: 35vh;
  overflow-y: hidden;
  overflow-x: hidden;
}
.section-elementos {
  height: 20vh;
  overflow-y: hidden;
  overflow-x: hidden;
}
.section-footer {
  height: auto;
  overflow-y: hidden;
  overflow-x: hidden;
}

.element-list {
  padding-top: 0px;
  height: 90%;
  overflow-y: auto;
  margin-top: 10px;
}

.bg-transparent {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  padding: 6px;
  backdrop-filter: blur(4px);
}

.element-item {
  border-radius: 8px;
  margin-bottom: 4px;
  background: rgba(255, 255, 255, 0.08);
  transition: all 0.15s ease;
  min-height: 36px;
}

.element-item:hover {
  background: rgba(255, 255, 255, 0.18);
}

.element-label {
  font-size: 13px;
  color: #ffffff;
  font-weight: 500;
}

.drag-handle {
  cursor: grab;
  color: rgba(255, 255, 255, 0.7);
}

.drag-handle:active {
  cursor: grabbing;
}

.drag-ghost {
  background: rgba(255, 255, 255, 0.25) !important;
  border-radius: 8px;
}

</style>
